import { LazyMotion, domAnimation, m } from 'motion/react';
import { IconMicrophone } from '@tabler/icons-react';
import { Tooltip } from '@caddie/ui-kit/components/tooltip';
import { useSuperbarTheme } from './hooks/useSuperbarTheme';
import { cn } from './utils/styles';
import { CADDIE_Z_INDEX } from '../constants/z-index';

type VoiceInputButtonProps = {
  onClick: () => void;
  size?: number;
  disabled?: boolean;
  tooltipLabel?: string;
};

export function VoiceInputButton({
  onClick,
  size = 20,
  disabled = false,
  tooltipLabel,
}: VoiceInputButtonProps) {
  const theme = useSuperbarTheme();

  const button = (
    <LazyMotion features={domAnimation}>
      <m.button
        type="button"
        onClick={disabled ? undefined : onClick}
        disabled={disabled}
        aria-label={disabled ? 'Microphone blocked' : 'Start voice input'}
        className={cn(
          'caddietw-border-0 caddietw-appearance-none caddietw-bg-transparent caddietw-p-2 caddietw-rounded-full caddietw-transition-colors',
          disabled
            ? 'caddietw-cursor-not-allowed'
            : 'caddietw-cursor-pointer hover:caddietw-bg-black/5'
        )}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: disabled ? 0.4 : 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.8 }}
        {...(disabled
          ? {}
          : { whileHover: { scale: 1.1 }, whileTap: { scale: 0.95 } })}
      >
        <span
          className="caddietw-relative caddietw-grid caddietw-place-items-center"
          style={{
            width: size,
            height: size,
            color: theme.components.assistantMessage.ctaButton.background,
          }}
        >
          <IconMicrophone size={size} />
        </span>
      </m.button>
    </LazyMotion>
  );

  return (
    <Tooltip
      label={
        disabled
          ? (tooltipLabel ??
            'Mic blocked - click the icon left of the address bar to allow')
          : 'Dictate'
      }
      position="top"
      withArrow
      zIndex={CADDIE_Z_INDEX.MENU}
    >
      <span>{button}</span>
    </Tooltip>
  );
}
